const fallbackApiUrl = 'https://d2141ekkpgdi0u.cloudfront.net';

export const frendApiUrl = (
  process.env.REACT_APP_FREND_API_URL ||
  fallbackApiUrl
).trim();

export async function postJson(path, body = {}, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (options.accessToken) {
    headers.Authorization = `Bearer ${options.accessToken}`;
  }

  let response;

  try {
    response = await fetch(`${frendApiUrl}${path}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
  } catch (error) {
    throw new Error(
      `Could not reach Frend API at ${frendApiUrl}. ` +
      'Update REACT_APP_FREND_API_URL if this backend has moved.'
    );
  }

  if (!response.ok) {
    throw new Error(`Frend API request failed with status ${response.status}.`);
  }

  return response.json();
}
